import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=bc005068&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc005068')) {
      api.createRecord('bc005068', component.options)
    } else {
      api.reload('bc005068', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=bc005068&", function () {
      api.rerender('bc005068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NM3SQIhSLGqT/JS/comp/openstreetmap.vue"
export default component.exports